import { getResourceById } from "@/modules/api/resourceTypeException.tsx";
import { assignedVmsQueryAtom } from "@/modules/compute/joinAssignedQuery.ts";
import { WVnc } from "@/modules/compute/WVnc.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export default function Vnc({ vmId, location }: { vmId: string; location: string }) {
    const vms = useSuspenseQueryAtom(assignedVmsQueryAtom(location));

    const vm = getResourceById(vms, vmId, "virtual_machine");

    return <WVnc vm={vm} location={location} />;
}
